const Cursor = ({ color, type }) => {
  const regular = (
    <svg
      width="24"
      height="24"
      viewBox="0 0 164 166"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M68.1477 0.982666C71.9217 0.982665 74.9811 4.04205 74.9811 7.816V24.1197C74.9811 27.8937 71.9217 30.9531 68.1477 30.9531C64.3738 30.9531 61.3144 27.8937 61.3144 24.1197V7.816C61.3144 4.04206 64.3738 0.982667 68.1477 0.982666ZM21.0392 20.4966C23.7077 17.828 28.0344 17.8279 30.703 20.4964L42.232 32.0249C44.9006 34.6934 44.9007 39.02 42.2321 41.6887C39.5636 44.3573 35.237 44.3574 32.5683 41.6889L21.0394 30.1604C18.3708 27.4919 18.3707 23.1652 21.0392 20.4966ZM115.249 20.4966C117.917 23.1652 117.917 27.4919 115.249 30.1604L103.72 41.6889C101.051 44.3574 96.7243 44.3573 94.0558 41.6887C91.3873 39.02 91.3874 34.6934 94.056 32.0249L105.585 20.4964C108.254 17.8279 112.58 17.828 115.249 20.4966ZM72.5574 70.1494L90.9897 134.662L100.567 122.691C104.451 117.836 111.693 117.435 116.09 121.831L133.863 139.604L142.012 131.454L124.239 113.682C119.843 109.285 120.244 102.043 125.099 98.1586L137.07 88.5816L72.5574 70.1494ZM57.8172 68.3059C55.5687 60.4363 62.8444 53.1607 70.714 55.4091L146.85 77.1622C154.997 79.49 157.117 90.046 150.501 95.3392L136.459 106.573L153.963 124.078C158.037 128.152 158.037 134.757 153.963 138.831L141.239 151.555C137.165 155.629 130.56 155.629 126.486 151.555L108.981 134.05L97.7473 148.093C92.454 154.709 81.8981 152.589 79.5703 144.442L57.8172 68.3059ZM1.52881 67.5957C1.52881 63.8218 4.5882 60.7624 8.36214 60.7624H24.6665C28.4405 60.7624 31.4999 63.8218 31.4999 67.5957C31.4999 71.3697 28.4405 74.4291 24.6665 74.4291H8.36214C4.5882 74.4291 1.52881 71.3697 1.52881 67.5957ZM42.2321 93.5103C44.9007 96.179 44.9006 100.506 42.232 103.174L30.703 114.703C28.0344 117.371 23.7077 117.371 21.0392 114.702C18.3707 112.034 18.3708 107.707 21.0394 105.039L32.5683 93.5101C35.237 90.8416 39.5636 90.8417 42.2321 93.5103Z"
        fill={color}
      />
    </svg>
  );

  const getSVGByType = (type) => {
    switch (type) {
      case "regular":
      default:
        return regular;
    }
  };

  return getSVGByType(type);
};

export default Cursor;
